import { useEffect } from 'react';

interface SchemaOrgProps {
  type: 'LocalBusiness' | 'Service' | 'WebPage' | 'FAQPage' | 'ImageGallery';
  data: Record<string, any>;
}

export function SchemaOrg({ type, data }: SchemaOrgProps) {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    let schema: Record<string, any> = {
      '@context': 'https://schema.org',
      '@type': type,
      ...data,
    };

    // Replace placeholder URLs with actual site URL
    const jsonString = JSON.stringify(schema).replace(/https:\/\/example\.com/g, siteUrl);
    schema = JSON.parse(jsonString);

    const scriptId = `schema-${type.toLowerCase()}`;
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(schema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [type, data]);

  return null;
}

export function updateMetaTags(tags: Record<string, string>) {
  Object.entries(tags).forEach(([name, content]) => {
    let meta = document.querySelector(`meta[name="${name}"]`) || 
                document.querySelector(`meta[property="${name}"]`);
    
    if (!meta) {
      meta = document.createElement('meta');
      if (name.startsWith('og:') || name.startsWith('twitter:')) {
        meta.setAttribute('property', name);
      } else {
        meta.setAttribute('name', name);
      }
      document.head.appendChild(meta);
    }
    
    meta.setAttribute('content', content);
  });
}

export function updateTitle(title: string) {
  document.title = title;
}

export function updateCanonical(path: string) {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
  
  if (!link) {
    link = document.createElement('link');
    link.rel = 'canonical';
    document.head.appendChild(link);
  }
  
  link.href = `${siteUrl}${path}`;
}
